import { useContext } from "react";
import { CompanyUserContext } from "../contexts/CompanyContext";

export function useCompanyUser() {
    const context = useContext(CompanyUserContext);
    
    return context;
}